import React from 'react'
import { css, Global } from '@emotion/react'

export function GlobalStyles(): React.ReactElement {
  return (
    <Global
      styles={css`
        body {
          background: rgb(255, 255, 255) !important;
          background-image: linear-gradient(
            0deg,
            rgb(255, 255, 255),
            rgb(255, 255, 255)
          ) !important;
          background-repeat: no-repeat;
        }
      `}
    />
  )
}
